import { mPerLat, mPerLon, utmToLl } from './geo';
import { toUTM } from './gisExport';

// control point proof: measured vs. known (target) coordinates
export const CP_TOL = { h: 0.03, v: 0.05 };
export const cpTol = (project) => ({ ...CP_TOL, ...(project?.cpTol || {}) });
const num = (v) => (v === '' || v == null || !Number.isFinite(+String(v).replace(',', '.')) ? null : +String(v).replace(',', '.'));

// form -> target {lat, lon, h, E, N, zone} or null
export function cpTarget(f) {
  const h = num(f.h);
  if (f.fmt === 'utm') {
    const E = num(f.E), N = num(f.N), zone = num(f.zone) || 32;
    if (E == null || N == null || E < 100000 || E > 900000 || N < 0 || N > 9400000) return null;
    const [lat, lon] = utmToLl(E, N, zone);
    return { lat, lon, h, E, N, zone };
  }
  const lat = num(f.lat), lon = num(f.lon);
  if (lat == null || lon == null || Math.abs(lat) > 90 || Math.abs(lon) > 180) return null;
  const u = toUTM(lat, lon, 32);
  return { lat, lon, h, E: u.x, N: u.y, zone: 32 };
}

// deviation of one measurement (gnss meta) from the target
export function cpEval(cp, g, tol) {
  const dN = (g.lat - cp.lat) * mPerLat(cp.lat), dE = (g.lon - cp.lon) * mPerLon(cp.lat), dH = Math.hypot(dN, dE);
  const dV = cp.h != null && g.ground != null ? g.ground - cp.h : null;
  const ok = dH <= tol.h && (dV == null || Math.abs(dV) <= tol.v) && g.qs !== 'exception' && !g.sim;
  return { dN, dE, dH, dV, ok };
}

export const cpLast = (cp) => (cp.meas || [])[cp.meas?.length - 1] || null;
export const cpCm = (v) => (v == null ? '–' : `${(v * 100).toFixed(1).replace('.', ',')} cm`);
